// @ts-nocheck
import { GoToPage } from '@hmpu/powerups.config.page.provider';
import type { FC } from 'react';
import classNames from "classnames";

type ListItemVariantKeys = 'panel' | 'link' | 'goto' | 'widget';

// options are common props/functions provided to each item
export type ListItemPropsOptions = {
  goToPage: GoToPage;
  currentPanel: string,
  setCurrentPanel: (v: string | null) => void;
  closeDialog: () => void;
  [key: string]: any; // catch all for any custom options
};

interface BaseProps {
  name: string;
  variant: ListItemVariantKeys;
  heading: string;
  underline: boolean;
  shouldRender: (props: any) => boolean;
  options: ListItemPropsOptions;
}

type ConditionalProps =
| {
  variant: "panel";
  component: FC<any>;
}
| {
  variant: "widget";
  component: FC<any>;
}
| {
  variant: "link";
  href: string;
  onClick: (e: any) => void;
}
| {
  variant: "goto";
  targetPage: string | number;
  onClick: (e: any) => void;
}

export type VariantProps<V = ListItemVariantKeys> = BaseProps & { variant: V } & ConditionalProps;

const defaultProps = {};

function propsToClassName(props:any) {
  return classNames({
    withUnderline: props.underline,
    withChevron: props.variant === 'panel',
  });
}

const ListItemVariantPanel = (props: VariantProps<"panel">) => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const { name, heading, component, options, ...buttonProps } = props;
  return (
    <button
      data-name={name}
      type="button"
      onClick={() => options.setCurrentPanel(name)}
      {...buttonProps}
    >
      {heading}
    </button>
  );
}
function ListItemVariantWidget(props: VariantProps<"widget">): any {
  const { component, ...componentProps } = props;
  const Widget = component;
  return <Widget {...componentProps} />
}

function ListItemVariantLink(props: VariantProps<"link">) {
  const { href, heading, onClick, options, ...buttonProps } = props;
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  return (<button role="link" type="button" onClick={(e: any) => {
    if (typeof onClick === "function") {
      onClick(props);
    } else {
      window.location.href = href;
    }
  }} {...buttonProps}>{heading}</button>)
}

function ListItemVariantGoto(props: VariantProps<"goto">) {
  const { targetPage, heading, onClick, options, ...buttonProps } = props;
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  return (<button type="button" onClick={(e: any) => {
    if (typeof onClick === "function") {
      onClick(props);
    } else {
      options.goToPage(targetPage);
      options.closeDialog();
    }
  }} {...buttonProps}>{heading}</button>
  )
}

function OptionsMenuListItem(props:VariantProps<any>): JSX.Element {
  const { variant, name, underline, ...childProps } = props;
  const classes = propsToClassName({underline, variant});

  const variantMap = {
    panel: ListItemVariantPanel,
    widget: ListItemVariantWidget,
    link: ListItemVariantLink,
    goto: ListItemVariantGoto
  };

  if (typeof variantMap[variant] === "undefined") {
    console.error(`Variant ${variant} is not available`);
    return null;
  }

  const ListItem = variantMap[variant];

  return (
    <li data-item-name={name}>
      <ListItem className={classes} name={name} {...childProps} />
    </li>
  );
}

OptionsMenuListItem.defaultProps = defaultProps;

export { OptionsMenuListItem }
